module.exports = __webpack_public_path__ + "static/media/cert_71.3e780bbe.jpg";